import { render, staticRenderFns } from "./PartsPointFinder2.vue?vue&type=template&id=83919542&"
import script from "./PartsPointFinder2.vue?vue&type=script&lang=js&"
export * from "./PartsPointFinder2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../themes/custom/ef2_custom/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports